import { FormattedShopifyProduct } from '@portal/types/shopify/product.formatted.types';

export const isCoreProduct = (product: FormattedShopifyProduct) => {
  return product.tags?.includes('Core Products');
};
